import React from "react";
import ExternalLegalRedirect from "../../components/common/ExternalLegalRedirect";
import { QIKTRUCK_PRIVACY_URL } from "../../constants/legal";

export default function PrivacyRedirect() {
  return (
    <ExternalLegalRedirect url={QIKTRUCK_PRIVACY_URL} label="Privacy Policy" />
  );
}
